module.exports = __webpack_public_path__ + "img/1.0a5493b9.png";